<template>
  <ProfileField
    id="email"
    label="Primary Email"
    :value="value"
    :error="errors.get('email')"
    type="email"
    @input="email => $emit('input', email)"
  />
</template>

<script type="text/babel">
import ProfileField from './ProfileField'

export default {
  name: 'ProfileEmail',
  components: {
    ProfileField,
  },
  props:{
    value: {
      type: String,
      required: true,
    },
    errors: {
      type: Object,
      required: true,
    },
  },
}
</script>
